<template>
	<div class="nd-container">
		<main-header :child="child" class="i-h"></main-header>
		<div class="nd-content" v-loading="loading">
			<div class="title">{{content.title}}</div>
			<div class="body" v-html="content.content"></div>
			<div class="floor col-center flex-sb">
				<div class="file-list">
					<el-dropdown @command="downFile" v-if="content.files && content.files.length">
						<span class="el-dropdown-link">
							附件列表<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command='index' v-for="(item,index) in content.files"
								:key="index">{{item.name}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="col-center">
					<div class="author">{{content.signing_information}}</div>
					<div>{{content.created_at}} </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	import {
		getNoticeDetail
	} from '@/common/api/home.js'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader
		},
		data() {
			return {
				loading: false,
				child: [],
				id: '',
				content: {}
			}
		},
		created() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		mounted() {
			// 添加面包屑
			this.child = [{
				path: "/index",
				name: "Index",
				title: this.authority === 'expert' ? '参赛作品评审' : '首页'
			}]
		},
		methods: {
			async getDetail() {
				this.loading = true
				const {
					data
				} = await getNoticeDetail({
					id: this.id
				})
				console.log(data)
				this.loading = false
				this.content = data
			},
			downFile(e){
				console.log(e)
				window.open(this.content.files[e].download_url)
			}
		}

	}
</script>

<style lang="scss" scoped>
	.nd-container {
		
		i-h {
			width: 100%;
		}

		.nd-content {
			background-color: white;
			.title {
				font-size: 24px;
				text-align: center;
				padding: 50px;
			}

			.body {
				max-width: 82.5rem;
				margin: 1.25rem auto;
				background: #F7FAFE;
				border-radius: 0.25rem;
				border: 1px solid #DCE1E7;
				padding: 20px;
				box-sizing: border-box;
			}

			.floor {
				max-width: 82.5rem;
				margin: 20px auto;
				color: #999;
				font-size: 14px;

				.file-list,
				.el-dropdown-link {
					cursor: pointer;
					color: #4979ff;
				}

				.author {
					color: #666;
					margin-right: 20px;
				}
			}
		}
	}
</style>